import moment from "moment";
import { useQuery } from "@apollo/react-hooks";
import { MY_CAFETERIA_GET_MENU } from "my-cafeteria/graphql";
import { useOcPolling } from "oc/hooks";

export const useMyCafeteriaMenu = ({
  contractCode,
}: {
  contractCode: string;
}) => {
  const { data, loading, error } = useQuery(MY_CAFETERIA_GET_MENU, {
    skip: !contractCode,
    fetchPolicy: "cache-and-network",
    pollInterval: useOcPolling(1000 * 60),
    variables: { contractCode },
  });

  let result = [];
  result = data?.getCafeteriaMenu.filter((item: any) => {
    let currentDate = moment().format("YYYYMMDD");
    if (item.endDate >= currentDate || item.endDate === "") {
      return true;
    }
    return false;
  });

  return {
    data: result,
    loading,
    error,
  };
};

export default useMyCafeteriaMenu;
